export interface OrganizationSettings {
	housekeepingSettings: HousekeepingSettings;
	apiKeySettings: ApiKeySetting[];
}

export interface QuickEndSettings {
	note: string,
	eventOutcomeId: number
}

export interface HousekeepingSettings {
	daysToKeepEvents: number;
	daysToKeepEventFiles: number;
}

export interface ApiKeySetting {
	keyType: string,
	keyValue: string
}

export interface HealthCheckSetting {
	healthCheckType: number;
	setCameraByDefault: boolean;
}

export interface HealthCheckType {
	id: number;
	label: string;
}

export enum HealthCheckTypeIds {
	EnabledOnly = 0,
	AllServers = 1
}

export enum HealthCheckTypeLabels {
	EnabledOnly = "Enabled Servers Only",
	AllServers = "All Servers"
}